import { service } from './service'
import { config } from './config'
import qs from 'qs'
import { useAuthStoreWithOut } from '@/store/modules/auth'
import { getState } from '@/store/modules/common'

const authStore = useAuthStoreWithOut()
const { default_headers } = config
const DOMAIN_KEY = 'portal'
export function getBaseURL (baseUrl) {
  if (window.$alarmorigin.search(DOMAIN_KEY) !== -1) {
    let url = window.$alarmorigin
    const reg = new RegExp('-\\d+-\\d+-\\d+')
    url = url.replace(reg, '')
    const key = 'portal-alarm'
    let replaceStr = 'portal-apm', joinStr = ''
    switch (baseUrl) {
      case 'api-desk':
      case 'deskapp':
        replaceStr = 'desk-app-management'
        break;
      case 'api-pi':
        let piUrl:any = getState().PIUrl
        if (piUrl) piUrl = piUrl.replace('portal-pi', 'api-pi')
        else piUrl = window.$alarmorigin.replace('portal-alarm', 'api-pi')
        return piUrl
      case 'api-ik':
        let ikUrl:any = getState().iKUrl
        if (ikUrl) ikUrl = ikUrl.replace('portal-iknowledge', 'api-iknowledge')
        else ikUrl = window.$alarmorigin.replace('portal-alarm', 'api-iknowledge')
        return ikUrl
      case 'api-m2i':
        replaceStr = 'api-m2i'
        break;
      case 'apm-dis':
          replaceStr = 'apm-dis'
          break;
      case 'msgpush':
        replaceStr = 'messagepush'
        joinStr = ''
        break;
      default:
        break;
    }
    url = `${url.replace(key, replaceStr)}/${joinStr}`
    return url
  }  
  return baseUrl
}

const request = (option: any) => {
  const { url, method, params, data, headersType, responseType, baseUrl, header, timeout } = option
  // console.log('request option',option)
  const headers = header?header:{}
  if (!headers['org-id'] && headers['org-id'] !== 0) {
    // console.log("url:", url, " org-id:", authStore.getOrgInfo.id)
    let orgId = authStore.getOrgInfo.id
    if ((window as any).$wujie) orgId = (window as any).$wujie.props.orgInfo.id
    headers['org-id'] = orgId
  }
  if (!headers['Tenant-Id'] && !['api-m2i','api-pi','api-ik'].includes(baseUrl)) {
    headers['Tenant-Id'] = authStore.getTenantId
  }
  // if (process.env.NODE_ENV !== 'production'){
  //   if (url) {
  //     if (url.indexOf('/api-apm/')==0 || url.indexOf('/apm-push/')==0 || url.indexOf('/alarm-process/')==0 || url.indexOf('/deskapp/')==0) {
  //       // headers['Tenant-Id'] = 'cluster01a99c5e30-006b-11eb-8201-00d8613dec81m2idemo'
  //       headers['Tenant-Id'] = '9eac64c330a5457a8f20b88f7279029b'
  //     }
  //   }
  // }
  return service({
    baseURL:getBaseURL(baseUrl),
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    withCredentials: true,
    timeout: timeout,
    headers: {
      'Content-Type': headersType || default_headers,
      ...headers
    },
    paramsSerializer : params => {
      return qs.stringify(params, { indices: false })
    }  
  })
}
export default {
  get: <T = any>(option: any) => {
    return request({ method: 'get', ...option }) as unknown as T
  },
  post: <T = any>(option: any) => {
    return request({ method: 'post', ...option }) as unknown as T
  },
  delete: <T = any>(option: any) => {
    return request({ method: 'delete', ...option }) as unknown as T
  },
  put: <T = any>(option: any) => {
    return request({ method: 'put', ...option }) as unknown as T
  }
}
